// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
import RelicChest from "./RelicChest";
import BtnHomeEnd from "../core/prefabs/BtnHomeEnd";
import BtnReplayEnd from "../core/prefabs/BtnReplayEnd";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { TransitionPoint } from '../rooting';
import UIButton from '../core/components/UIButton';
import GameUI from '../scenes/GameUI';
import { GameDataHandler } from '../GameDataHandler';
import { RelicNameValues } from '../level/relics/relic';
import { RunSettingsHandler } from '../level/RunSettingsHandler';
/* END-USER-IMPORTS */

export default class EndScreen extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.visible = false;
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // treasure_pile_png
    const treasure_pile_png = scene.add.image(0, 290, "game-all", "treasure-pile.png");
    treasure_pile_png.scaleX = 1.33;
    treasure_pile_png.scaleY = 1.33;
    this.add(treasure_pile_png);

    // sail
    const sail = scene.add.container(0, -160);
    this.add(sail);

    // sail-top
    const sail_top = scene.add.image(-7, -140, "game-all", "sail.png");
    sail.add(sail_top);

    // cord2
    const cord2 = scene.add.image(681, 79, "game-all", "sail-cord.png");
    cord2.angle = 24.5;
    sail.add(cord2);

    // cord1
    const cord1 = scene.add.image(-694, 84, "game-all", "sail-cord.png");
    cord1.angle = -25.5;
    sail.add(cord1);

    // sailText
    const sailText = scene.add.text(-5, -285, "", {});
    sailText.setOrigin(0.5, 0.5);
    sailText.text = "Congratulations!";
    sailText.setStyle({ "align": "center", "color": "#b34637", "fontFamily": "ARCO", "fontSize": "70px" });
    sailText.setPadding({"right":7});
    this.add(sailText);

    // grizz
    const grizz = scene.add.image(252, 281, "game-all", "grizz.png");
    this.add(grizz);

    // ice
    const ice = scene.add.image(-401, 289, "game-all", "ice.png");
    this.add(ice);

    // panda_png
    const panda_png = scene.add.image(439, 273, "game-all", "panda.png");
    this.add(panda_png);

    // relicChest
    const relicChest = new RelicChest(scene, 0, 250);
    relicChest.scaleX = 0.35;
    relicChest.scaleY = 0.35;
    this.add(relicChest);

    // screen
    const screen = scene.add.container(0, -106);
    this.add(screen);

    // tablet
    const tablet = scene.add.image(0, 1, "common", "holder-large.png");
    screen.add(tablet);

    // iconTrophy
    const iconTrophy = scene.add.image(56, -5, "common", "icon-total-gems.png");
    screen.add(iconTrophy);

    // iconGems
    const iconGems = scene.add.image(-232, -5, "common", "icon-gems.png");
    screen.add(iconGems);

    // bestScoreText
    const bestScoreText = scene.add.bitmapText(146, -3, "arco", "0");
    bestScoreText.setOrigin(0, 0.5);
    bestScoreText.text = "0";
    bestScoreText.fontSize = 65;
    screen.add(bestScoreText);

    // endScoreText
    const endScoreText = scene.add.bitmapText(-145, -2, "arco", "0");
    endScoreText.setOrigin(0, 0.5);
    endScoreText.text = "0";
    endScoreText.fontSize = 65;
    endScoreText.dropShadowAlpha = 0;
    screen.add(endScoreText);

    // btnHomeEnd
    const btnHomeEnd = new BtnHomeEnd(scene, -120, 15);
    this.add(btnHomeEnd);

    // btnReplayEnd
    const btnReplayEnd = new BtnReplayEnd(scene, 120, 15);
    this.add(btnReplayEnd);

    // sailText (components)
    const sailTextFitTextToBounds = new FitTextToBounds(sailText);
    sailTextFitTextToBounds.MaxWidth = 660;
    sailTextFitTextToBounds.MinFontSize = 5;
    const sailTextLocaliseText = new LocaliseText(sailText);
    sailTextLocaliseText.copyId = "congratulations";

    this.cover = cover;
    this.treasure_pile_png = treasure_pile_png;
    this.sail = sail;
    this.sailText = sailText;
    this.grizz = grizz;
    this.ice = ice;
    this.panda_png = panda_png;
    this.relicChest = relicChest;
    this.screen = screen;
    this.tablet = tablet;
    this.iconTrophy = iconTrophy;
    this.iconGems = iconGems;
    this.bestScoreText = bestScoreText;
    this.endScoreText = endScoreText;
    this.btnHomeEnd = btnHomeEnd;
    this.btnReplayEnd = btnReplayEnd;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.newHighScore = false;
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private treasure_pile_png: Phaser.GameObjects.Image;
  private sail: Phaser.GameObjects.Container;
  private sailText: Phaser.GameObjects.Text;
  private grizz: Phaser.GameObjects.Image;
  private ice: Phaser.GameObjects.Image;
  private panda_png: Phaser.GameObjects.Image;
  private relicChest: RelicChest;
  private screen: Phaser.GameObjects.Container;
  private tablet: Phaser.GameObjects.Image;
  private iconTrophy: Phaser.GameObjects.Image;
  private iconGems: Phaser.GameObjects.Image;
  private bestScoreText: Phaser.GameObjects.BitmapText;
  private endScoreText: Phaser.GameObjects.BitmapText;
  private btnHomeEnd: BtnHomeEnd;
  private btnReplayEnd: BtnReplayEnd;
  public screenStartY: number = 700;
  public characterStartY: number = 1300;

  /* START-USER-CODE */
  private particles!: Phaser.GameObjects.Particles.ParticleEmitterManager;
  private endScore!: number;
  private highScore!: number;
  private activeRelics!: RelicNameValues[];
  private newHighScore: boolean;

  awake() {
    this.cover.setInteractive();

    this.btnHomeEnd.on(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Map);
    });

    this.btnReplayEnd.on(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Replay);
    });

    let line = new Phaser.Geom.Line(-960, -400, 1920, -300);
    this.particles = this.scene.make.particles(
      {
        key: 'game',
        emitters: [
          {
            name: 'explode',
            on: false,
            frame: ['gem-blue.png', 'gem-green.png', 'gem-pink.png'],
            // x: -960,
            // y: -400,
            angle: { min: 0, max: 360 },
            //scale: { min: 0.5, max: 1.5 },
            scale: { start: 0.2, end: 1.5, ease: Phaser.Math.Easing.Cubic.Out },
            alpha: { start: 1, end: 0, ease: Phaser.Math.Easing.Cubic.In },
            speed: { min: 500, max: 900 },
            gravityY: 600,
            lifespan: 5000,
            quantity: 1
            //emitZone: { source: new Phaser.Geom.Circle(0,0,200) }
          }
        ]
      },
      false
    );
    this.add(this.particles);
  }

  activate(endScore: number, highScore: number, activeRelics: RelicNameValues[]) {
    this.endScore = endScore;
    this.highScore = highScore;
    this.activeRelics = activeRelics;

    this.newHighScore = false;
    if (this.endScore > this.highScore || this.highScore == 0) this.newHighScore = true;

    this.bestScoreText.setText(this.highScore.toString());

    this.transitionIn();
  }

  transitionIn() {
    app.audioHandler.playSound(this.scene, 'SndEndSting2', 'sfx');
    let startDelay = 50;

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 500,
      delay: startDelay,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    /*let screenFinishY = this.screen.y;
    this.screen.y = this.screenStartY;
    this.scene.add.tween({
      targets: this.screen,
      y: { from: this.screenStartY, to: screenFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + 750
    });*/

    this.screen.scale = 0;
    this.scene.add.tween({
      targets: this.screen,
      scaleX: 1,
      scaleY: 1,
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + 750
    });

    let sailFinishY = this.sail.y;
    this.sail.y = sailFinishY - 500;
    this.scene.add.tween({
      targets: this.sail,
      y: { from: this.sail.y, to: sailFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + 450
    });

    let sailTFinishY = this.sailText.y;
    this.sailText.y = sailTFinishY - 500;
    this.scene.add.tween({
      targets: this.sailText,
      y: { from: this.sailText.y, to: sailTFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + 450
    });

    let characterDelay = 0;
    let coinFinishY = this.treasure_pile_png.y;
    this.treasure_pile_png.y = this.characterStartY;
    this.scene.add.tween({
      targets: this.treasure_pile_png,
      y: { from: this.characterStartY, to: coinFinishY },
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + characterDelay + 0
    });

    characterDelay += 500;

    let grizzFinishY = this.grizz.y;
    this.grizz.y = this.characterStartY;
    this.scene.add.tween({
      targets: this.grizz,
      y: { from: this.characterStartY, to: grizzFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + characterDelay + 0
    });
    let iceFinishY = this.ice.y;
    this.ice.y = this.characterStartY;
    this.scene.add.tween({
      targets: this.ice,
      y: { from: this.characterStartY, to: iceFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + characterDelay + 50
    });
    let pandaFinishY = this.panda_png.y;
    this.panda_png.y = this.characterStartY;
    this.scene.add.tween({
      targets: this.panda_png,
      y: { from: this.characterStartY, to: pandaFinishY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out,
      delay: startDelay + characterDelay + 100
    });

    let relicFinishY = this.relicChest.y;
    this.relicChest.y = this.characterStartY;
    this.scene.add.tween({
      targets: this.relicChest,
      y: { from: this.characterStartY, to: relicFinishY },
      duration: 900,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + characterDelay + 120
    });

    this.scene.time.delayedCall(characterDelay + startDelay + 120, () => {
      //app.audioHandler.playSound(this.scene, 'SndGameOver','sfx');
      let emitter = this.particles.emitters.getByName('explode');
      emitter?.explode(150, 0, relicFinishY);
    });

    this.iconGems.alpha = 0;
    this.endScoreText.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconGems, this.endScoreText],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2000
    });

    this.iconTrophy.alpha = 0;
    this.bestScoreText.alpha = 0;
    this.scene.add.tween({
      targets: [this.iconTrophy, this.bestScoreText],
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: startDelay + 2500
    });

    let endTimeCounterTween = this.scene.tweens.addCounter({
      from: 0,
      to: this.endScore,
      duration: 2000,
      delay: startDelay + 2750,
      ease: Phaser.Math.Easing.Linear,
      onUpdate: (tween, target, param) => {
        this.endScoreText.text = Math.floor(endTimeCounterTween.getValue()).toString();
      }
    });
    this.scene.time.delayedCall(startDelay + 2750, this.playCounters, [], this);

    app.audioHandler.playSound(this.scene, 'SndBearSwitch', 'sfx');

    if (this.newHighScore) {
      let bestTimeCounterTween = this.scene.tweens.addCounter({
        from: this.highScore,
        to: this.endScore,
        duration: 2000,
        delay: startDelay + 5000,
        ease: Phaser.Math.Easing.Linear,
        onStart: () => {},
        onUpdate: (tween, target, param) => {
          this.bestScoreText.text = Math.floor(bestTimeCounterTween.getValue()).toString();
        },
        onComplete: () => {
          this.bestScoreText.setTint(0xffef00);
          this.scene.add.tween({
            targets: this.bestScoreText,
            alpha: { from: 1, to: 0 },
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.InOut,
            repeat: 2,
            yoyo: true,
            delay: 250
          });
        }
      });
      this.scene.time.delayedCall(startDelay + 5000, this.playCounters, [], this);
    }

    this.btnHomeEnd.alpha = 0;
    this.btnReplayEnd.alpha = 0;
    this.scene.add.tween({
      targets: [this.btnHomeEnd, this.btnReplayEnd],
      alpha: { from: 0, to: 1 },
      y: { from: 500, to: 15 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      delay: startDelay + 3000
    });

    this.scene.time.delayedCall(1100, this.startIdles, [], this);

    let unlockedRelics = this.scene.game.registry.get(GameDataHandler.keys.CollectedRelics) as RelicNameValues[];
    let newRelics = this.scene.game.registry.get(GameDataHandler.keys.NewRelics) as RelicNameValues[];
    this.relicChest.showRelics(unlockedRelics, newRelics, this.activeRelics, false, false);
  }

  playCounters() {
    app.audioHandler.playSound(this.scene, 'SndEndCount', 'sfx');
  }

  startIdles() {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
